export default {
  gameLobby: "Phòng đợi chơi",
  account: "ID",
  balance: "Số dư",
  searchGame: "Tìm kiếm",
  gameSearch: "Tìm kiếm tên gọi trò chơi",
  myFollowedGames: "Trò chơi yêu thích",
  allGames: "Toàn bộ",
  like: "Trò chơi đã theo dõi của tôi",
  new: "Mới",
  hot: "Hot nhất",
  reco: "Giới thiệu",
  enterGame: "vào trò chơi",
  searchText: `Kết quả liên quan <0>{{searchValue}}</0> :`,
  goToHotGames: "Truy cập trò chơi hot",
  soEmpty: "Oops~Trống không",
  cantFindGame: "Không tìm thấy trò chơi phù hợp",
  noGameCanPlay: "Ái chà~ Hiện tại không có trò chơi có thể chơi",
  cantFindPage: "Không tìm thấy trang",
  sorryPageRunAway: "Rất tiếc, trang này không tồn tại.",
  backToHome: "Trở về màn hình chính",
  authFail: "Chứng nhận vô hiệu",
  goWrong: "Chứng nhận của tài khoản đã vô hiệu, vui lòng đóng trang",
  maintain: "Đang bảo trì",
  annoucement: "Công bố toàn trang web",
  websiteMaintenance: "Website đang bảo trì",
  systemMaintain: "Hệ thống đang nâng cấp bảo trì, vui lòng quay lại sau!",
  recentPlayed: "Chơi gần đây",
  send: "Gửi đi",
  payoutRank: "Chỉ số tiền thưởng ",
  playerRank: "Xếp hạng người chơi",
  rank: "Xếp thứ",
  recommend: "Trò chơi nổi bật",
  idRound: "ID/số vòng",
  payout: `Số tiền thưởng <span class="highlight">(¥)</span>`,
  payoutInfo: {
    title: "Cập nhật mỗi giờ",
    content: [
      `Khi chỉ số phát thưởng > 0, nghĩa là phát thưởng 1 giờ trước <span class="highlight">cao hơn</span> giá trị lý thuyết.`,
      `Khi chỉ số phát thưởng < 0, nghĩa là phát thưởng 1 giờ trước <span class="highlight">thấp hơn</span> giá trị lý thuyết.`,
    ],
  },
  playerInfo: {
    title: "Xếp hạng 30 ngày qua",
    content: [`Xếp hạng tổng thể dựa trên số tiền thanh toán của người chơi từ nhiều đến ít.`],
  },
  newToOld:"mới → cũ",
  oldToNew:"cũ → mới",
  favorite: "Theo dõi",
}
